import { CplatApiResponse } from '@/types/api';
import { UserInfo } from '@/types/user-info';
import { queryOptions } from '@tanstack/react-query';
import { CPLAT_API_ROUTES, v3BaseURL } from '.';
import { Stores } from '@/types/stores';

export const sellerQueries = {
  all: () => ['sellerQueries'],
  getInfo: (params: { cplatToken: string }) =>
    queryOptions({
      queryKey: [...sellerQueries.all(), 'getInfo'],
      queryFn: () => fetchUserInfo(params),
      enabled: !!params.cplatToken,
    }),
  getStores: (params: { cplatToken: string }) =>
    queryOptions({
      queryKey: [...sellerQueries.all(), 'getStores'],
      queryFn: () => fetchStores(params),
      enabled: !!params.cplatToken,
    }),
};

export const fetchUserInfo = async (params: { cplatToken: string }) => {
  const res = await fetch(`${v3BaseURL}${CPLAT_API_ROUTES.getInfo}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
  const json: CplatApiResponse<UserInfo[]> = await res.json();
  return json;
};

export const fetchStores = async (params: { cplatToken: string }) => {
  const res = await fetch(`${v3BaseURL}${CPLAT_API_ROUTES.getStores}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
  const json: CplatApiResponse<Stores[]> = await res.json();
  return json;
};
